var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.245,
    cy: 15.841,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.064,
    cy: 19.062,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.997,
    cy: 12.004,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.825,
    cy: 21.247,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 21a9 9 0 1 1 5.646-16h-1.646a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -2 0v1.531a10.995 10.995 0 1 0 -7 19.469 1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.707 15.707a1 1 0 0 0 0-1.414l-2.707-2.707v-5.586a1 1 0 0 0 -2 0v6a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ef7f067b2a157e63a697222e9dd1d701.svg";
export { ForwardRef as ReactComponent };